module.exports = BD.Model.extend({
    organization: BD.belongsTo('Billy.Organization'),
    account: BD.belongsTo('Billy.Account'),
    type: BD.attr('string'),
    priority: BD.attr('number')
})
